import Vue from 'vue'
import Router from 'vue-router'

import AdminGuard from './general/adminGuard'
import ExternalPath from './general/externalPath'

import Home from '@/components/site/home/Home'
import About from '@/components/site/about/About'
import AllCourses from '@/components/site/courses/AllCourses'
import Register from '@/components/site/courses/Register'
import Terms from '@/components/site/legal/Terms'
import Privacy from '@/components/site/legal/Privacy'
import Contact from '@/components/site/about/Contact'
import Dashboard from '@/components/dashboard/Dashboard'

import AuthRoutes from './auth/routes'
import CoursesRoutes from './courses/routes'
import QuestionsRoutes from './questions/routes'
import ContentRoutes from './content/routes'
import UsersRoutes from './users/routes'
import MyCoursesRoutes from './myCourses/routes'
import ProgressRoutes from './progress/routes'
import PaymentsRoutes from './payments/routes'

const baseRoutes = [
  {path: '', component: Home},
  {path: '/about', component: About},
  {path: '/courses', component: AllCourses},
  {path: '/register', component: Register},
  {path: '/terms', component: Terms},
  {path: '/privacy', component: Privacy},
  {path: '/contact', component: Contact},
  {path: '/dashboard', component: Dashboard, beforeEnter: AdminGuard},
  {path: '*', beforeEnter: ExternalPath}
]

const routes = baseRoutes.concat(
  AuthRoutes,
  QuestionsRoutes,
  ContentRoutes,
  CoursesRoutes,
  UsersRoutes,
  MyCoursesRoutes,
  ProgressRoutes,
  PaymentsRoutes
)

Vue.use(Router)

export default new Router({
  routes,
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js